import { createTheme } from '@mui/material/styles';
import type { } from '@mui/x-data-grid/themeAugmentation';
import { COLORS } from '../../constants/colors';


const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.principalColor,
    },
  },
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: '16px', // Bordes redondeados para los modales
          animation: 'zoomIn 0.3s ease-in-out', // Animación al mostrar el modal
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        '@global': {
          '@keyframes zoomIn': {
            '0%': {
              transform: 'scale(0.8)',
              opacity: 0,
            },
            '100%': {
              transform: 'scale(1)',
              opacity: 1,
            },
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: 2000,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: 'rgba(0, 0, 0, 0.54)', // Color por defecto

        },
        colorPrimary: {
          '&.Mui-checked': {
            color: COLORS.principalColor, // Color cuando está seleccionado
          },
          '&:hover': {
            backgroundColor: 'transparent', // Sin fondo al pasar el mouse
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.23)', // Borde por defecto
            },
            '&:hover fieldset': {
              borderColor: COLORS.principalColor, // Borde en hover
            },
            '&.Mui-focused fieldset': {
              borderColor: COLORS.principalColor, // Borde en foco
            },
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.23)', // Borde por defecto
            },
            '&:hover fieldset': {
              borderColor: COLORS.principalColor, // Borde en hover
            },
            '&.Mui-focused fieldset': {
              borderColor: COLORS.principalColor, // Borde en foco
            },
          },
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        thumb: {
          backgroundColor: COLORS.principalColor, // Color del "pulgar" del slider
        },
        track: {
          backgroundColor: COLORS.principalColor, // Color del track seleccionado
        },
        rail: {
          backgroundColor: 'rgba(0, 0, 0, 0.26)', // Color del track no seleccionado
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            color: COLORS.principalColor, // Color del botón al estar encendido
          },
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: COLORS.principalColor, // Color de la pista cuando está encendido
          },
        },
        track: {
          backgroundColor: 'rgba(0, 0, 0, 0.26)', // Color de la pista apagada
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          backgroundColor: COLORS.principalColor, // Color del indicador
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        textColorPrimary: {
          color: COLORS.principalColor, // Color del texto no seleccionado
          '&.Mui-selected': {
            color: COLORS.principalColor, // Color del texto seleccionado
          },
        },
      },
    },



    MuiDataGrid: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          backgroundColor: '#fff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
          border: 'none',
          padding: 0,
        },
        columnHeaders: {
          backgroundColor: '#f8f9fa',
          borderBottom: 'none',
          '&:focus, &:focus-within': {
            outline: 'none',
          },
        },
        columnHeader: {
          '&:focus, &:focus-within': {
            outline: 'none',
          },
          // backgroundColor: 'rgba(0, 0, 0, 0.04)',
          backgroundColor: '#f5f5f5',

          '&:hover .MuiDataGrid-columnSeparator': {
            visibility: 'visible',
            pointerEvents: 'auto',
          },
        },
        row: {
       
          borderBottom: 'none',
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.02)',
          },
        },
        cell: {
          // un poco más de aire
          // padding: '12px',
          '&:focus, &:focus-within': {
            outline: 'none',
          },
        },
        footerContainer: {
          borderTop: 'none',
          "& .MuiDataGrid-selectedRowCount": {
            display: "none",
          },
        },
        columnSeparator: {
          color: 'rgba(0, 0, 0, 0.15)',
          // Por defecto “invisible” y sin eventos
          visibility: 'hidden',
          pointerEvents: 'none',
        },
      },
    },





  },
});

export default theme;
